import Grid from '@mui/material/Grid';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslate } from '@im/react-localization';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';

export const AutoDenial = (props: {
  error?: string | null;
  handleJustification: (e: any) => void;
  handleSupressDenial: (e: any) => void;
  isDenialchecked: boolean;
  justification?: string;
}) => {
  const isError = props.isDenialchecked === true && !props.justification;
  const translate = useTranslate();
  return (
    <>
      <Grid
        alignItems="center"
        container
        mt={1}
        spacing={1}
        sx={{
          color: (theme) => theme.palette.text.primary,
          fontSize: '0.875rem',
        }}
      >
        <Grid item>
          <Typography fontWeight={'bold'} mb={1} mt={1} variant="body2">
            {translate('Pricing.SuppressAutoDenial')}
          </Typography>
        </Grid>
        <Grid item>
          <Switch
            checked={props.isDenialchecked}
            onChange={props.handleSupressDenial}
          />
        </Grid>
      </Grid>
      <Grid>
        {props.isDenialchecked && (
          <>
            <Typography
              color={isError ? '#B11616' : '#333'}
              fontWeight={'bold'}
              mb={1}
              mt={1}
              variant="body2"
            >
              {translate('Pricing.Justification')}
            </Typography>
            <TextField
              error={isError}
              multiline
              onChange={(e) => props.handleJustification(e.target.value)}
              required
              rows={3}
              sx={{
                mb: 2,
                width: '300px',
              }}
              variant="outlined"
            ></TextField>
            <FormHelperText sx={{ color: '#B11616', ml: 0, mt: -2 }}>
              {isError && props.error}
            </FormHelperText>
          </>
        )}
      </Grid>
    </>
  );
};
